<template>
  <j-modal
    :title="title"
    :width="550"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
    dialogClass="resize-for-mobile"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" @keyup.enter.native="handleOk">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('disp.itemText')">
          <a-input
            :placeholder="$t('disp.ph.input', [$t('disp.itemText')])"
            v-decorator="['itemText', validatorRules.itemText]"
            :maxLength="100"
          />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('disp.itemText1')">
          <a-input
            :placeholder="$t('disp.ph.input', [$t('disp.itemText1')])"
            v-decorator="['itemText1', {}]"
            :maxLength="100"
          />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('disp.itemText2')">
          <a-input
            :placeholder="$t('disp.ph.input', [$t('disp.itemText2')])"
            v-decorator="['itemText2', {}]"
            :maxLength="100"
          />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('disp.itemValue')">
          <a-input
            :placeholder="$t('disp.ph.input', [$t('disp.itemValue')])"
            v-decorator="['itemValue', validatorRules.itemValue]"
            :maxLength="100"
          />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('disp.note')">
          <a-input
            v-decorator="['description']"
            :placeholder="$t('disp.ph.input', [$t('disp.note')])"
            :maxLength="255"
          />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('disp.sort')">
          <j-input-number :min="0" :max="9999" v-decorator="['sortOrder', { initialValue: 0 }]" style="width: 80px" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('disp.status')" hasFeedback>
          <a-switch
            :unCheckedChildren="$t('disp.invalid')"
            :checkedChildren="$t('disp.valid')"
            @change="onChose"
            v-model="visibleCheck"
          />
        </a-form-item>
      </a-form>
    </a-spin>
  </j-modal>
</template>

<script>
import pick from 'lodash/pick'
import { addDictItem, editDictItem } from '@/api/api'
import { getAction, postAction, putAction } from '@/api/manage'
import JInputNumber from '@/components/JInputNumber'

export default {
  name: 'DictItemModal',
  components: { JInputNumber },
  data() {
    return {
      title: '',
      visible: false,
      visibleCheck: true,
      model: {},
      dictId: '',
      status: 1,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
      loading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        itemText: { rules: [{ required: true, message: this.$t('disp.rules.require') }] },
        itemValue: {
          rules: [{ required: true, message: this.$t('disp.rules.require') }, { validator: this.validateItemValue }],
        },
      },
    }
  },
  created() {},
  methods: {
    validateItemValue(rule, value, callback) {
      if (value && value.length > 0) {
        if (new RegExp(/^[\x00-\xff]+$/).test(value) || true) {
          var params = {
            id: this.model.id,
            dictId: this.model.dictId,
            itemValue: value,
          }
          getAction('/blaze-sys/k00/k0006/DictItemManage/duplicateCheck', params).then((res) => {
            if (res.success) {
              callback()
            } else {
              callback(this.$t('disp.rules.duplicate', [this.$t('disp.itemValue')]))
            }
          })
        } else {
          callback(this.$t('disp.rules.half'))
        }
      } else {
        callback()
      }
    },
    add(dictId) {
      this.title = this.$t('disp.btn.add')
      this.dictId = dictId
      this.edit({})
    },
    edit(record) {
      if (record.id) {
        this.title = this.$t('disp.btn.edit')
        this.dictId = record.dictId
        this.visibleCheck = record.status == 1 ? true : false
      }
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.model.dictId = this.dictId
      this.model.status = this.status
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(this.model, 'itemText', 'itemText1', 'itemText2', 'itemValue', 'description', 'sortOrder')
        )
      })
    },
    onChose(checked) {
      if (checked) {
        this.status = 1
        this.visibleCheck = true
      } else {
        this.status = 0
        this.visibleCheck = false
      }
    },
    // 確定
    handleOk() {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      const that = this
      // フォーム検証をトリガー
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          values.itemText = (values.itemText || '').trim()
          values.itemText1 = (values.itemText1 || '').trim()
          values.itemText2 = (values.itemText2 || '').trim()
          values.itemValue = (values.itemValue || '').trim()
          values.description = (values.description || '').trim()
          let formData = Object.assign(this.model, values)
          formData.status = this.status
          let obj
          if (!this.model.id) {
            obj = addDictItem(formData)
          } else {
            obj = editDictItem(formData)
          }
          obj
            .then((res) => {
              if (res.success) {
                that.$message.success(that.$t(res.message))
                that.$emit('ok')
              }
            })
            .finally(() => {
              that.loading = false
              that.close()
            })
        } else {
          that.loading = false
        }
      })
    },
    // 閉じる
    handleCancel() {
      this.close()
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
  },
}
</script>
